export default "__VITE_ASSET__DoSONG9r__"